import styled from "styled-components";

export const SettingUserIcon = styled.svg`
  width: 40px;
  height: 40px;
  fill: ${({ theme }) => theme?.colors?.iconSettingUser};

  @media (min-width: 744px) {
    width: 50px;
    height: 50px;
  }

  @media (min-width: 1024px) {
    width: 65px;
    height: 65px;
  }
`;

export const CloseButtonIcon = styled.svg`
  width: 24px;
  height: 24px;

  @media (min-width: 428px) {
    width: 27px;
    height: 27px;
  }

  @media (min-width: 744px) {
    width: 40px;
    height: 40px;
  }
`;

export const OpenMenuButtonIcon = styled.svg`
  width: 24px;
  height: 24px;

  @media (min-width: 428px) {
    width: 27px;
    height: 27px;
  }

  @media (min-width: 744px) {
    width: 40px;
    height: 40px;
  }
`;
